module.exports = (__webpack_require__(0))(81);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/views/body/ItemView.js from dll-reference girder_lib
// module id = 12
// module chunks = 0